export enum QuoteColumnField {
  UnreadMessageNotification = 'unreadMessageNotification',
  Favorite = 'favorite',
  QuoteId = 'quoteId',
  QuoteNumber = 'quoteNumber',
  AccountName = 'accountName',
  StatusChangeDate = 'statusChangeDate',
  ModifiedDate = 'modifiedDate',
  EffectiveDate = 'effectiveDate',
  Status = 'status',
  Address = 'address',
  UnderwritingStatus = 'underwritingStatus',
  ReasonForReferral = 'reasonForReferral',
  TotalPremium = 'totalPremium',
  Underwriter = 'underwriter',
  ProductOffering = 'offering',
  ProductLabel = 'productLabel',
  BusinessClass = 'businessClass',
  CreatedByUser = 'createdByUser',
  CreatedAt = 'createdAt',
  Producer = 'producer',
  Brokerage = 'brokerage',
  QuoteType = 'quoteType',
  Cancel = 'cancel',
  Menu = 'menu',
  WritingCompany = 'writingCompany',
  Jurisdiction = 'jurisdiction',
  DuplicateQuotes = 'hasDuplicateQuotes',
  QuoteOrigin = 'quoteOrigin',
  QuoteSource = 'reportingQuoteSource',
  UnderwritingActivityType = 'underwritingActivityType',
  // Currently UW homepage only fields
  FlaggedAsImportant = 'uwFlaggedAsImportant',
  TransactionType = 'transactionType',
  ComplianceReviewDate = 'complianceReviewDate',
}
